import React, { useEffect, useState } from "react";

export const GamePlayer = () => {
    const [scale, setScale] = useState(1);

    useEffect(() => {
        const BASE_W = 700;
        const BASE_H = 500;

        const updateScale = () => {
            const scaleX = window.innerWidth / BASE_W;
            const scaleY = window.innerHeight / BASE_H;

            setScale(Math.min(scaleX, scaleY) * 0.95);
        };

        updateScale();
        window.addEventListener("resize", updateScale);

        return () => window.removeEventListener("resize", updateScale);
    }, []);

    return (
        <div
            style={{
                position: "relative",
                height: "100%", 
                inset: 0,
                background: "radial-gradient(circle,#1E3A5F 0%, #000000 100%)",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    position: "relative",
                    top: "520px",
                    left: "900px",
                    width: "800px",
                    height: "750px",
                    transform: `translate(-50%, -50%) scale(${scale})`,
                    transformOrigin: "center center",
                }}
            >
                <iframe
                    src="https://openhtml5games.github.io/games-mirror/dist/mariohtml5/main.html"
                    title="Mario"
                    style={{
                        width: "800px",
                        height: "600px",
                        border: "none",
                        display: "block",
                    }}
                />
            </div>
        </div>
    );
};

export const KidsDay = () => {
    const [error, setError] = useState("");

    useEffect(() => {
        const gameUrl = 'lib/kidsday.gba';
        const loaderUrl = 'https://cdn.emulatorjs.org/stable/data/loader.js';
        let script = null;
        let cancelled = false;
        let timer = null;

        window.EJS_player = '#game-player';
        window.EJS_core = 'gba';
        window.EJS_pathtodata = 'https://cdn.emulatorjs.org/stable/data/'; 
        window.EJS_biosUrl = 'https://cdn.emulatorjs.org/stable/data/gba_bios.bin'; 
        window.EJS_gameUrl = gameUrl; 

        const loadEmulator = async () => {
            try {
            const resolvedGameUrl = new URL(gameUrl, window.location.href);

            if (resolvedGameUrl.origin === window.location.origin) {
                const response = await fetch(resolvedGameUrl.href, { method: 'HEAD' });
                const contentType = response.headers.get('content-type') || '';

                if (!response.ok || contentType.includes('text/html')) {
                throw new Error(`${resolvedGameUrl.pathname} was not found. Put the ROM in public/roms or update EJS_gameUrl.`);
                }
            }

            if (!cancelled && document.querySelector('#game-player')) {
                setError("");

            script = document.createElement('script');
                script.src = loaderUrl;
            script.async = true;
                script.onerror = () => {
                if (!cancelled) {
                    setError('Could not load EmulatorJS. Check the loader URL.');
                }
                };
            document.body.appendChild(script);
            }
            } catch (err) {
            if (!cancelled) {
                setError(err.message || 'Could not start EmulatorJS.');
            }
            }
        };

        timer = setTimeout(loadEmulator, 50);

        return () => {
            cancelled = true;
            clearTimeout(timer);
            if (script && document.body.contains(script)) {
            script.remove();
            }
            delete window.EJS_player;
            delete window.EJS_gameUrl;
            delete window.EJS_core;
            delete window.EJS_biosUrl;
            delete window.EJS_pathtodata;
        };
    }, []);

    return (
        <div style={{ width: '100%', height: '100%', margin: '0 auto' }}>
            {error && (
            <div style={{ color: '#fff', background: '#8A1C1C', padding: '12px', marginBottom: '12px' }}>
                {error}
            </div>
            )}
            <div id="game-player" style={{ width: '100%', height: '100%' }} />
        </div>
    );
};
